/* @jsx h */
import { defineComponent, h, Fragment } from "vue";
import { useTheme } from "./useTheme";

export const ThemeSwitcher = defineComponent({
  name: "ThemeSwitcher",
  setup() {
    const { currentTheme, themeOptions, setTheme } = useTheme();

    return () => (
      <Fragment>
        {themeOptions.map((theme) => (
          <li class="py-0.5" key={theme.id}>
            <a
              onClick={() => setTheme(theme.id)}
              class={`flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-[13px] transition-colors duration-150 cursor-pointer ${
                currentTheme.value === theme.id
                  ? "text-accent bg-accent/10"
                  : "text-base-content/60 hover:bg-accent/5"
              }`}
            >
              {currentTheme.value === theme.id ? (
                <span class="material-symbols-outlined text-[18px]">
                  radio_button_checked
                </span>
              ) : (
                <span class="material-symbols-outlined text-[18px]">
                  radio_button_unchecked
                </span>
              )}
              <span
                class="w-3.5 h-3.5 rounded-full border border-base-content/20 flex-shrink-0"
                style={{
                  background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.base100} 100%)`,
                }}
              />
              {theme.label}
            </a>
          </li>
        ))}
      </Fragment>
    );
  },
});
